import {useEffect} from 'react';

import {useDatadogRum} from '../../../util/datadog/datadogRum';
import {useStatsigGateBackendLineConstruction} from '../../../util/rampFeatureFlags';

export const useBackendLineConstruction = (entityName: string) => {
  const ddRum = useDatadogRum();
  const canUseBackendLineConstruction =
    useStatsigGateBackendLineConstruction(entityName);

  // track
  useEffect(() => {
    ddRum.addAction('Backend Line Construction: Panel Load', {
      useBackendLineConstruction: canUseBackendLineConstruction,
    });
  }, [canUseBackendLineConstruction, ddRum]);

  return canUseBackendLineConstruction;
};
